import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getTeams = (ids) => {
  return axios.post(
    `${getBackendUrl()}/teams`,
    { ids: ids },
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
};

export const getAllTeams = () => {
  return axios.get(`${getBackendUrl()}/teams/all`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const getTeamsOfUser = (id) => {
  return axios.get(`${getBackendUrl()}/teams/user/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const getTeamsOfCaptain = (id) => {
  return axios.get(`${getBackendUrl()}/teams/captain/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const uploadTeamAvatar = (id, file) => {
  const formData = new FormData();
  formData.append("image", file);
  return axios.post(`${getBackendUrl()}/team/${id}/avatar`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const createTeam = (team) => {
  return axios.put(`${getBackendUrl()}/team`, 
    team,
    {headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const removeTeam = (id) => {
  return axios.delete(`${getBackendUrl()}/team/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};
